import { signal } from "@preact/signals-react"
import { useEffect } from "react"
import { fetchMachineStatus } from "../utils/api"

export const loading = signal(false)
export const error = signal(null)
export const machineStatusData = signal({})
export const modified = signal(false) // allows a component to flag the data as modified so subsequent calls to the hook will reload it
export const parameterHash = signal(null)

const fetchData = async (businessEntityId, utg, config, accessToken) => {

    const hash = await import('object-hash').then(module => module.default || module)
    // if any parameters have changed then flag as modified so that the hook will reload the data
    const currentParametersHash = hash([businessEntityId, utg, config, accessToken])
    if (currentParametersHash != parameterHash.value) {
        modified.value = true
        parameterHash.value = currentParametersHash
    }

    // short-circuit if we have a pending request, are waiting for parameters or have already received an error
    if (loading.value || !businessEntityId || !utg || !config || !accessToken || error.value || !modified.value) {
        return
    }

    // short-circuit if we already have the data
    if (machineStatusData.value.MachinePermanentId == utg.MachinePermanentId) {
        return
    }
    
    try {
        loading.value = true
        machineStatusData.value = await fetchMachineStatus(businessEntityId, utg.MachinePermanentId, config, accessToken)
    } catch (err) {
        error.value = err
    }
    finally {
        loading.value = false
        modified.value = false
    }  
    
}

export default function useMachineStatusData(businessEntityId, utg, config, accessToken) {
    useEffect(() => {
        fetchData(businessEntityId, utg, config, accessToken)
    }, [businessEntityId, utg, config, accessToken])

    return {
        machineStatusData, loading, error
    }
}